import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Button, ButtonBase, Grid, Typography } from '@mui/material'

import { formatAddress } from '../../utils/helpers'
import useDates from '../../utils/hooks/useDates'

import OrderHistoryContext from './context'
import useStyles from './index.styles'

const OrderCard = ({ order, hasMultipleFolders }: { order: OrderTrackingItem; hasMultipleFolders: boolean }) => {
  const classes = useStyles
  const navigate = useNavigate()
  const location = useLocation()
  const { order: selectedOrder } = useContext(OrderHistoryContext)
  const { formatDateTimeShortMonth } = useDates()

  return (
    <ButtonBase
      onClick={() => {
        navigate(`${order.orderNumber}`, { state: location.state })
      }}
      sx={classes.orderCardButton}
    >
      <Grid
        container={true}
        size={12}
        sx={[
          classes.orderCard,
          /\/order-history\/[^/]+$/.test(location.pathname) && selectedOrder?.orderNumber === order.orderNumber ? classes.selectedOrderCard : {},
        ]}
      >
        <Grid container={true} sx={classes.orderCardHeader}>
          <Grid container={true} sx={classes.orderDetailsColumn}>
            <Typography variant="overline" sx={classes.orderLabel}>
              Order
            </Typography>
            {order.orderNumber && <Typography variant="body1">#{order.orderNumber}</Typography>}
            <Grid container={true} sx={classes.orderInformation}>
              {hasMultipleFolders && (
                <Typography variant="body2" sx={classes.secondaryText}>
                  {order.folderName}
                </Typography>
              )}
              <Typography variant="body2" sx={classes.secondaryText}>
                {order.information.first} {order.information.last}
              </Typography>
              <Typography variant="body2" sx={classes.secondaryText} align="left">
                {formatAddress(order.information.address)}
              </Typography>
              <Typography variant="body2" sx={classes.secondaryText}>
                Updated {formatDateTimeShortMonth(order.lastUpdated)}
              </Typography>
            </Grid>
          </Grid>
          <Typography variant="caption" sx={classes.secondaryText}>
            {order.orderStatus}
          </Typography>
        </Grid>
        {!['delivered', 'delivery exception', 'cancelled'].includes(order.orderStatus.toLowerCase()) && order.trackingUrl && (
          <Button
            variant="contained"
            size="small"
            color="secondary"
            disableElevation
            href={order.trackingUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={classes.trackShipmentButton}
          >
            Track Shipment
          </Button>
        )}
      </Grid>
    </ButtonBase>
  )
}

export default OrderCard
